export default __webpack_public_path__ + "static/media/webcam4.96e83fd4.jfif";